export type CheckoutFlow = "authed" | "guest";
export type CheckoutPlace = "pricing_card" | "home_pricing_page";

export function getCheckoutTrackingContext(
  pathname: string,
  locale: string = "en"
): {
  checkoutFlow: CheckoutFlow;
  checkoutPlace: CheckoutPlace;
  checkoutLocale: string;
} {
  const checkoutPlace = pathname.includes("/home")
    ? "home_pricing_page"
    : "pricing_card";

  return {
    checkoutFlow: checkoutPlace === "home_pricing_page" ? "authed" : "guest",
    checkoutPlace,
    checkoutLocale: locale || "en",
  };
}
